import React, { useContext } from "react";
import SiteContext from "./SiteContext.jsx";
import PlatformContext from "./PlatformContext.jsx";
import BackIcon from "./icons/BackIcon.jsx";

export default function TopBar({ title }: { title: string }) {
  const { platform, chromeHeight } = useContext(PlatformContext);
  const { primaryColor } = useContext(SiteContext);
  const align = platform === "ios" ? "center" : "left";

  return (
    <div
      className='tw-z-10 tw-bg-[var(--bg-color)] tw-text-white tw-shadow-md'
      style={
        {
          "--bg-color": primaryColor,
          "--chrome-height": `${chromeHeight}px`,
        } as React.CSSProperties
      }
    >
      {/* Spacer to account for the space taken by the OS chrome */}
      <div className='tw-h-[var(--chrome-height)] tw-w-full'></div>

      <div className='tw-flex tw-items-center tw-gap-7 tw-p-5'>
        <BackIcon className='tw-h-7 tw-w-7 tw-fill-[currentColor]' />
        <div className={align === "center" ? "tw-m-auto" : ""}>
          <h1 className='tw-m-0 tw-text-xl tw-font-medium tw-leading-tight'>{title}</h1>
        </div>

        {/* Placeholder to even out the centering */}
        <div className='tw-h-7 tw-w-7 tw-opacity-0' />
      </div>
    </div>
  );
}
